import React, { FC } from 'react'
import { FlexRow } from 'components/Flex'
import styles from 'styles/components/pagination.module.scss'
import text from 'styles/utility/text.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { State } from 'index'
import { Spacer } from 'components/Utility'
import classNames from 'classnames'

type Props = {
  perPage: number
  total: number
}

const Pagination: FC<Props> = (props) => {
  const { perPage, total } = props

  const query = useSelector((state: State) => state.router.location.query)
  const currentPage = Number(query?.page ?? '1')

  const pathname = useSelector((state: State) => state.router.location.pathname)
  const dispatch = useDispatch()

  const prev = () => {
    dispatch(push(pathname + '?page=' + (currentPage - 1)))
  }

  const next = () => {
    dispatch(push(pathname + '?page=' + (currentPage + 1)))
  }

  const goToPage = (page: number) => {
    dispatch(push(pathname + '?page=' + page))
  }

  const totalPages = Math.ceil(total / perPage)

  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === totalPages

  // 「1からtotalPagesの数値」までの配列を生成。
  const ArrayPage = Array.from({ length: totalPages }, (_, index) => index + 1)

  // 配列から以下の条件で数値を切り出すための変数。
  const maxVariable =
    totalPages <= 4
      ? currentPage - 3
      : currentPage === totalPages
      ? currentPage - 4
      : currentPage + 1 === totalPages
      ? currentPage - 3
      : currentPage - 2

  // 配列から以下の条件で数値を切り出すための変数。
  const minVariable =
    totalPages <= 4
      ? currentPage + 3
      : currentPage === 1
      ? currentPage + 4
      : currentPage === 2
      ? currentPage + 3
      : currentPage + 2

  return (
    <>
      {perPage >= total ? null : (
        <FlexRow justifyContent={'center'} alignItems={'center'}>
          <button className={styles.arrowPrev} disabled={isFirstPage} onClick={prev}>
            <img
              src={isFirstPage ? '/icon/grey/arrow_next.svg' : '/icon/blue/arrow_next.svg'}
              alt={'前のページに戻る'}
            />
          </button>
          <Spacer size={20} />
          {ArrayPage.slice(Math.max(maxVariable, 1) - 1, Math.min(minVariable, totalPages)).map((page) => (
            <React.Fragment key={page}>
              {currentPage == page ? (
                <button
                  className={classNames(styles.currentPage, text.font_small, text.font_bold)}
                  onClick={() => goToPage(page)}
                >
                  {page}
                </button>
              ) : (
                <button
                  className={classNames(styles.pages, text.color_blue_main, text.font_small, text.font_bold)}
                  onClick={() => goToPage(page)}
                >
                  {page}
                </button>
              )}
              <Spacer size={12} />
            </React.Fragment>
          ))}
          <Spacer size={8} />
          <button className={styles.arrowNext} disabled={isLastPage} onClick={next}>
            <img
              src={isLastPage ? '/icon/grey/arrow_next.svg' : '/icon/blue/arrow_next.svg'}
              alt={'次のページに進む'}
            />
          </button>
        </FlexRow>
      )}
    </>
  )
}

export default Pagination
